import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { capitalize } from 'underscore.string';

const SurveyQuestion = ({
  options,
  onSelected = () => {},
  type = 'singleChoice',
  value,
  showDropdownOnDesktop = false,
  placeholder,
}) => {
  const selectedValues = type === 'singleChoice' && value
    ? [value]
    : value || [];

  const buttonListClass = classNames({
    'visible-xs': showDropdownOnDesktop,
  });

  return <div>
    {showDropdownOnDesktop && type === 'singleChoice' && <select
      value={value || ''}
      className="form-control narrow hidden-xs"
      onChange={event => onSelected(event.target.value)}
   >
      {options && [{ label: placeholder, value: '' }, ...options].map((option, i) =>
        <option value={option.value} key={i}>
          {capitalize(option.label)}
        </option>)}
    </select>}
    <div className={buttonListClass}>
      {options && options.map((option, i) => {
        const isSelected = selectedValues.includes(option.value);
        const className = classNames({
          'survey__choice-btn': true,
          'survey__choice-btn--selected': isSelected,
        });

        return <button
          className={className}
          onClick={event => {
            event.preventDefault();
            onSelected(option.value);
          }}
          key={i}
        >
          <span className="survey__choice-btn-text">{capitalize(option.label)}</span>
          {isSelected && <span className="survey__choice-btn-icon icon icon-tick-2" />}
        </button>;
      })}
    </div>
  </div>;
};

SurveyQuestion.propTypes = {
  options: PropTypes.array,
  onSelected: PropTypes.func,
  type: PropTypes.string,
  value: PropTypes.any,
  showDropdownOnDesktop: PropTypes.bool,
  placeholder: PropTypes.string,
};

export default SurveyQuestion;



// WEBPACK FOOTER //
// ./src/components/survey/surveyQuestion.js